import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useExplorer } from "@/context/ExplorerContext";
import { EASE } from "@/components/lurio/Motion";

export const StickyBar = () => {
  const { t } = useExplorer();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const hero = document.getElementById("hero");
    const order = document.getElementById("commander");
    if (!hero) return;
    let pastHero = false;
    let onOrder = false;
    const update = () => setShow(pastHero && !onOrder);
    const o1 = new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; update(); }, { threshold: 0.05 });
    const o2 = new IntersectionObserver(([e]) => { onOrder = e.isIntersecting; update(); }, { threshold: 0.2 });
    o1.observe(hero);
    if (order) o2.observe(order);
    return () => { o1.disconnect(); o2.disconnect(); };
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sticky-cta-bar"
          className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3 md:hidden"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.4, ease: EASE }}
        >
          <div className="paper-card flex items-center justify-between gap-3 border border-ink/10 p-2 ps-4 backdrop-blur">
            <div className="leading-tight">
              <p className="font-latin text-[1rem] font-semibold text-ink" dir="ltr">{t.bookTitle}</p>
              <p className="text-xs font-semibold text-ink-soft"><bdi>{t.sticky.price}</bdi></p>
            </div>
            <a href="#commander" data-testid="sticky-cta-button" className="inline-flex min-h-[48px] shrink-0 items-center rounded-full bg-coral px-5 text-[0.95rem] font-bold text-cream hover:bg-coral-deep">
              {t.nav.order}
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
